// extracted by mini-css-extract-plugin
export default {"app":"app--tsuxG","list":"list--j1WWH","details":"details--cVrmG"};